import { SupportAnnounce7Component } from "./SupportAnnounce7Component";

export function EntrepreneurAnnounce7FormComponent() {

    return (
        <SupportAnnounce7Component />
    );

}
